import apiService from "../../api/api.service";
import {
  SimilarProductsRequest,
  SimilarProductsResponse,
} from "./similarProducts.types";

/**
 * Fetch similar products by product slug
 */
export const fetchSimilarProducts = (
  slug: string,
  { page, per_page, section_id, seque, ...filterFields }: SimilarProductsRequest,
) => {
  const filters = Object.fromEntries(
    Object.entries(filterFields).filter(([, v]) => v !== undefined),
  );
  return apiService.get<SimilarProductsResponse>(
    `/products/${slug}/similar`,
    {
      params: {
        page,
        per_page,
        ...(section_id !== undefined ? { section_id } : {}),
        ...(seque !== undefined ? { seque } : {}),
        ...(Object.keys(filters).length ? { filters } : {}),
      },
    },
  );
};